module.exports = __webpack_public_path__ + "img/rank-1.2.008a5810.svg";